module.exports = __webpack_public_path__ + "img/secure-payment-fill.cd360f37.svg";